import { useMutation } from '@tanstack/react-query';
import { resetSplitPaymentsGroup } from '../../services/payments';

interface Props {
  onSuccess?: (
    data: Awaited<ReturnType<typeof resetSplitPaymentsGroup>>,
  ) => void;
  onError?: (error: Error) => void;
}

function useResetSplitPaymentGroup({ onSuccess, onError }: Props = {}) {
  return useMutation({
    mutationFn: ({ splitPaymentsGroupId }: { splitPaymentsGroupId: string }) =>
      resetSplitPaymentsGroup(splitPaymentsGroupId),
    onSuccess,
    onError,
  });
}

export default useResetSplitPaymentGroup;
